import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
export default function HeroIntroduction() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="20949" id="treatments-hero" className="relative w-full min-h-[85vh] flex items-center justify-center bg-background overflow-hidden">
      {}
      <div className="absolute inset-0 pointer-events-none select-none">
        <div className="w-full h-full bg-[url(https://images.unsplash.com/photo-1519824145371-296894a0daa9?q=80&w=2070&auto=format&fit=crop)] bg-cover bg-center opacity-40 grayscale-[20%]" />
      </div>

      {}
      <div ref={ref} className={cn("relative z-10 max-w-4xl mx-auto px-6 text-center flex flex-col items-center gap-8 transition-all duration-1000 ease-out transform bg-white/40 backdrop-blur-md rounded-[2.5rem] shadow-xl py-16", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10")}>
        {}
        <h1 className="text-accent font-sans text-sm md:text-base font-semibold tracking-widest uppercase">
          Our Treatments
        </h1>

        {}
        <h1 className="font-serif text-[48px] md:text-[72px] leading-tight tracking-tight text-primary">
          Expert Care for Lasting Wellness
        </h1>

        {}
        <p className="font-sans font-normal text-[18px] md:text-[22px] text-secondary max-w-2xl leading-relaxed">
          Experience specialized chiropractic and acupuncture treatments at our premium clinics in Limassol and Nicosia. Your journey to recovery starts here.
        </p>

        {}
        <div className="pt-6">
          <Button asChild className="bg-accent text-accent-foreground hover:bg-accent hover:opacity-90 transition-all duration-300 rounded-lg h-16 px-12 text-lg font-semibold shadow-lg border-none scale-100 hover:scale-105">
            <Link to="/ContactPage">
              Book Your Appointment
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}